<template>
    <div>
        <slot
            :brief="brief"
            :orders="orders"
            :is-loading="isLoading"
            :current-page="currentPage"
            :number-of-pages="numberOfPages"
            :load-orders-page="loadOrdersPage"
        />
    </div>
</template>

<script>
    import { get } from 'lodash';
    import ActivationBriefMixin from '../mixins/ActivationBriefMixin';
    import ContactsMixin from '../mixins/ContactsMixin';
    import ActivationBriefProductsMixin from '../mixins/ActivationBriefProductsMixin';

    const ORDER_PAGE_SIZE = 5;

    export default {
        name: 'ActivationBriefOrdersListProvider',
        mixins: [
            ActivationBriefMixin,
            ActivationBriefProductsMixin,
            ContactsMixin,
        ],
        data() {
            return {
                isLoading: false,
                orders: [],
                currentPage: 1,
            };
        },
        computed: {
            numberOfPages() {
                return Math.ceil(get(this, 'brief.orders', []).length / ORDER_PAGE_SIZE);
            }
        },
        methods: {
            loadOrdersPage(page = 1) {
                this.isLoading = true;
                this.currentPage = page;

                this.orders = get(this, 'brief.orders', []).slice((page-1)*ORDER_PAGE_SIZE, page*ORDER_PAGE_SIZE);

                return Promise.all(
                    this.orders.map((order) =>
                        this.getProducts(order.items.map((item) => item['product_id']))
                    .then(products => order.products = products))
                )
                .catch((error) => console.log(error))
                .then(() => {
                    this.isLoading = false;
                });
            }
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadActivationBrief(),
                    ]);
                })
                .then(() => this.loadOrdersPage())
                .catch((error) => console.log(error))
                .then(() => {
                    this.isLoading = false;
                });
        },
    };
</script>
